export default __webpack_public_path__ + "static/media/access_denied.5eb62b0b.png";